
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/study-abroad-partner/settings/user-account",
      function () {
        return require("private-next-pages/admin/study-abroad-partner/settings/user-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/study-abroad-partner/settings/user-account"])
      });
    }
  